// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-type-selection-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
  overflow: hidden;
}

.user-type-selection-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.user-type-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 32px 64px rgba(0, 0, 0, 0.12),
    0 16px 32px rgba(0, 0, 0, 0.08),
    0 8px 16px rgba(0, 0, 0, 0.04);
  padding: 48px;
  max-width: 900px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: slideInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.user-type-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f, #0877BC);
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0%, 100% { background-position: 200% 0; }
  50% { background-position: -200% 0; }
}

.user-type-header {
  text-align: center;
  margin-bottom: 48px;
  position: relative;
}

.header-decoration {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.decoration-circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  animation: pulse 2s ease-in-out infinite;
}

.decoration-circle:nth-child(2) {
  animation-delay: 0.2s;
}

.decoration-circle:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes pulse {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

.user-type-title {
  font-size: 3rem;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.user-type-subtitle {
  font-size: 1.25rem;
  color: #64748b;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
  font-weight: 400;
}

.user-type-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 48px;
}

.user-type-option {
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  padding: 32px 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 280px;
  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: var(--animation-delay);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-type-option::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--type-color), var(--type-color));
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 0;
}

.user-type-option:hover {
  border-color: var(--type-color);
  transform: translateY(-8px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 8px 16px rgba(0, 0, 0, 0.06);
}

.user-type-option:hover::before {
  opacity: 0.03;
}

.user-type-option.selected {
  border-color: var(--type-color);
  background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(6, 90, 143, 0.03));
  box-shadow: 
    0 20px 40px rgba(8, 119, 188, 0.2),
    0 8px 16px rgba(8, 119, 188, 0.15);
  transform: translateY(-8px);
}

.user-type-option.selected::before {
  opacity: 0.08;
  background: linear-gradient(135deg, #0877BC, #065a8f);
}

.user-type-option.selected::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f);
  border-radius: 20px 20px 0 0;
}

.user-type-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: linear-gradient(135deg, var(--type-color), var(--type-color));
  color: white !important;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

/* Ensure Material-UI icons are white */
.user-type-icon-container .MuiSvgIcon-root,
.user-type-icon-container svg {
  color: white !important;
  fill: white !important;
}

.user-type-option.selected .user-type-icon-container {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  color: white !important;
}

.user-type-option.selected .user-type-icon-container .MuiSvgIcon-root,
.user-type-option.selected .user-type-icon-container svg {
  color: white !important;
  fill: white !important;
}

.user-type-option:hover .user-type-icon-container {
  transform: scale(1.1) rotate(5deg);
}

.user-type-option:hover .user-type-icon-container .MuiSvgIcon-root,
.user-type-option:hover .user-type-icon-container svg {
  color: white !important;
  fill: white !important;
}

.icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--type-color);
  opacity: 0;
  filter: blur(20px);
  transition: opacity 0.3s ease;
  z-index: -1;
}

.user-type-option:hover .icon-glow {
  opacity: 0.3;
}

.user-type-option.selected .icon-glow {
  background: #0877BC;
  opacity: 0.4;
}

.user-type-icon {
  font-size: 36px !important;
  z-index: 1;
  position: relative;
  color: white !important;
  transition: color 0.3s ease;
}

.user-type-option.selected .user-type-icon {
  color: white !important;
}

.user-type-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.user-type-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px 0;
  letter-spacing: -0.01em;
}

.user-type-description {
  font-size: 1rem;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 16px 0;
  font-weight: 400;
}

.user-type-features {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.feature-tag {
  background: linear-gradient(135deg, var(--type-color), var(--type-color));
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  opacity: 0.9;
  transition: all 0.3s ease;
}

.user-type-option.selected .feature-tag {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  opacity: 1;
  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);
}

.user-type-check {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  z-index: 2;
}

.checkmark {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--type-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: checkmarkAppear 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes checkmarkAppear {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.user-type-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.continue-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  max-width: 240px;
}

.keyboard-hint {
  font-size: 0.75rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
  opacity: 0.8;
  text-align: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 0.8; transform: translateY(0); }
}

.back-button {
  background: #f8fafc;
  color: #475569;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px 24px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.back-button:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.continue-button {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 16px 32px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  min-width: 160px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  letter-spacing: 0.025em;
}

.continue-button.enabled {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  box-shadow: 
    0 8px 24px rgba(8, 119, 188, 0.3),
    0 4px 8px rgba(8, 119, 188, 0.2);
}

.continue-button.enabled:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 12px 32px rgba(8, 119, 188, 0.4),
    0 6px 12px rgba(8, 119, 188, 0.3);
}

.continue-button.disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.continue-button.disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .user-type-card {
    padding: 32px 24px;
    margin: 16px;
    border-radius: 20px;
  }

  .user-type-title {
    font-size: 2.5rem;
  }

  .user-type-subtitle {
    font-size: 1.125rem;
  }

  .user-type-options {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .user-type-option {
    padding: 24px 20px;
    min-height: 240px;
  }

  .user-type-icon-container {
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
  }

  .user-type-icon {
    font-size: 28px !important;
    color: white !important;
  }

  .user-type-name {
    font-size: 1.25rem;
  }

  .user-type-description {
    font-size: 0.9rem;
  }

  .user-type-actions {
    flex-direction: column;
    gap: 16px;
  }

  .back-button,
  .continue-button {
    width: 100%;
    max-width: none;
  }
}

@media (max-width: 480px) {
  .user-type-selection-container {
    padding: 16px;
  }

  .user-type-card {
    padding: 24px 20px;
  }

  .user-type-title {
    font-size: 2rem;
  }

  .user-type-option {
    padding: 20px 16px;
    min-height: 200px;
  }

  .user-type-icon-container {
    width: 56px;
    height: 56px;
    margin-bottom: 16px;
  }

  .user-type-icon {
    font-size: 24px !important;
    color: white !important;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .user-type-card {
    background: rgba(30, 41, 59, 0.95);
    border-color: rgba(255, 255, 255, 0.1);
  }

  .user-type-title {
    color: #f1f5f9;
  }

  .user-type-subtitle {
    color: #94a3b8;
  }

  .user-type-option {
    background: #1e293b;
    border-color: #334155;
  }

  .user-type-name {
    color: #f1f5f9;
  }

  .user-type-description {
    color: #94a3b8;
  }

  .back-button {
    background: #334155;
    color: #f1f5f9;
    border-color: #475569;
  }

  .back-button:hover {
    background: #475569;
    border-color: #64748b;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserTypeSelection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uFAAuF;EACvF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;qFAGmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;;kCAGgC;EAChC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,2DAA2D;EAC3D,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yEAAyE;EACzE,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,oFAAoF;EACpF;;sCAEoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yEAAyE;EACzE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;EACzE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,YAAY,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD;;oCAEkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B;;qCAEmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kCAAkC;IAClC,sCAAsC;EACxC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF","sourcesContent":[".user-type-selection-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n.user-type-selection-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.user-type-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  box-shadow: \n    0 32px 64px rgba(0, 0, 0, 0.12),\n    0 16px 32px rgba(0, 0, 0, 0.08),\n    0 8px 16px rgba(0, 0, 0, 0.04);\n  padding: 48px;\n  max-width: 900px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: slideInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.user-type-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f, #0877BC);\n  background-size: 200% 100%;\n  animation: shimmer 3s ease-in-out infinite;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  0%, 100% { background-position: 200% 0; }\n  50% { background-position: -200% 0; }\n}\n\n.user-type-header {\n  text-align: center;\n  margin-bottom: 48px;\n  position: relative;\n}\n\n.header-decoration {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.decoration-circle {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.decoration-circle:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.decoration-circle:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 0.4; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.2); }\n}\n\n.user-type-title {\n  font-size: 3rem;\n  font-weight: 800;\n  color: #1a202c;\n  margin-bottom: 16px;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.user-type-subtitle {\n  font-size: 1.25rem;\n  color: #64748b;\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0 auto;\n  font-weight: 400;\n}\n\n.user-type-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n  margin-bottom: 48px;\n}\n\n.user-type-option {\n  background: #ffffff;\n  border: 2px solid #e2e8f0;\n  border-radius: 20px;\n  padding: 32px 24px;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-height: 280px;\n  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;\n  animation-delay: var(--animation-delay);\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-type-option::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--type-color), var(--type-color));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: 0;\n}\n\n.user-type-option:hover {\n  border-color: var(--type-color);\n  transform: translateY(-8px);\n  box-shadow: \n    0 20px 40px rgba(0, 0, 0, 0.1),\n    0 8px 16px rgba(0, 0, 0, 0.06);\n}\n\n.user-type-option:hover::before {\n  opacity: 0.03;\n}\n\n.user-type-option.selected {\n  border-color: var(--type-color);\n  background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(6, 90, 143, 0.03));\n  box-shadow: \n    0 20px 40px rgba(8, 119, 188, 0.2),\n    0 8px 16px rgba(8, 119, 188, 0.15);\n  transform: translateY(-8px);\n}\n\n.user-type-option.selected::before {\n  opacity: 0.08;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n}\n\n.user-type-option.selected::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n  border-radius: 20px 20px 0 0;\n}\n\n.user-type-icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, var(--type-color), var(--type-color));\n  color: white !important;\n  margin-bottom: 24px;\n  position: relative;\n  z-index: 1;\n  transition: all 0.3s ease;\n}\n\n/* Ensure Material-UI icons are white */\n.user-type-icon-container .MuiSvgIcon-root,\n.user-type-icon-container svg {\n  color: white !important;\n  fill: white !important;\n}\n\n.user-type-option.selected .user-type-icon-container {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  color: white !important;\n}\n\n.user-type-option.selected .user-type-icon-container .MuiSvgIcon-root,\n.user-type-option.selected .user-type-icon-container svg {\n  color: white !important;\n  fill: white !important;\n}\n\n.user-type-option:hover .user-type-icon-container {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.user-type-option:hover .user-type-icon-container .MuiSvgIcon-root,\n.user-type-option:hover .user-type-icon-container svg {\n  color: white !important;\n  fill: white !important;\n}\n\n.icon-glow {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: var(--type-color);\n  opacity: 0;\n  filter: blur(20px);\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.user-type-option:hover .icon-glow {\n  opacity: 0.3;\n}\n\n.user-type-option.selected .icon-glow {\n  background: #0877BC;\n  opacity: 0.4;\n}\n\n.user-type-icon {\n  font-size: 36px !important;\n  z-index: 1;\n  position: relative;\n  color: white !important;\n  transition: color 0.3s ease;\n}\n\n.user-type-option.selected .user-type-icon {\n  color: white !important;\n}\n\n.user-type-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n\n.user-type-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 12px 0;\n  letter-spacing: -0.01em;\n}\n\n.user-type-description {\n  font-size: 1rem;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0 0 16px 0;\n  font-weight: 400;\n}\n\n.user-type-features {\n  display: flex;\n  justify-content: center;\n  margin-top: auto;\n}\n\n.feature-tag {\n  background: linear-gradient(135deg, var(--type-color), var(--type-color));\n  color: white;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0.025em;\n  text-transform: uppercase;\n  opacity: 0.9;\n  transition: all 0.3s ease;\n}\n\n.user-type-option.selected .feature-tag {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  opacity: 1;\n  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);\n}\n\n.user-type-check {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  z-index: 2;\n}\n\n.checkmark {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--type-color);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: checkmarkAppear 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes checkmarkAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.user-type-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.continue-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  max-width: 240px;\n}\n\n.keyboard-hint {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 0;\n  font-weight: 500;\n  opacity: 0.8;\n  text-align: center;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 0.8; transform: translateY(0); }\n}\n\n.back-button {\n  background: #f8fafc;\n  color: #475569;\n  border: 2px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 16px 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  min-width: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.back-button:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.continue-button {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 16px 32px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  min-width: 160px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  letter-spacing: 0.025em;\n}\n\n.continue-button.enabled {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  box-shadow: \n    0 8px 24px rgba(8, 119, 188, 0.3),\n    0 4px 8px rgba(8, 119, 188, 0.2);\n}\n\n.continue-button.enabled:hover {\n  transform: translateY(-3px);\n  box-shadow: \n    0 12px 32px rgba(8, 119, 188, 0.4),\n    0 6px 12px rgba(8, 119, 188, 0.3);\n}\n\n.continue-button.disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.continue-button.disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .user-type-card {\n    padding: 32px 24px;\n    margin: 16px;\n    border-radius: 20px;\n  }\n\n  .user-type-title {\n    font-size: 2.5rem;\n  }\n\n  .user-type-subtitle {\n    font-size: 1.125rem;\n  }\n\n  .user-type-options {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .user-type-option {\n    padding: 24px 20px;\n    min-height: 240px;\n  }\n\n  .user-type-icon-container {\n    width: 64px;\n    height: 64px;\n    margin-bottom: 20px;\n  }\n\n  .user-type-icon {\n    font-size: 28px !important;\n    color: white !important;\n  }\n\n  .user-type-name {\n    font-size: 1.25rem;\n  }\n\n  .user-type-description {\n    font-size: 0.9rem;\n  }\n\n  .user-type-actions {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .user-type-selection-container {\n    padding: 16px;\n  }\n\n  .user-type-card {\n    padding: 24px 20px;\n  }\n\n  .user-type-title {\n    font-size: 2rem;\n  }\n\n  .user-type-option {\n    padding: 20px 16px;\n    min-height: 200px;\n  }\n\n  .user-type-icon-container {\n    width: 56px;\n    height: 56px;\n    margin-bottom: 16px;\n  }\n\n  .user-type-icon {\n    font-size: 24px !important;\n    color: white !important;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .user-type-card {\n    background: rgba(30, 41, 59, 0.95);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .user-type-title {\n    color: #f1f5f9;\n  }\n\n  .user-type-subtitle {\n    color: #94a3b8;\n  }\n\n  .user-type-option {\n    background: #1e293b;\n    border-color: #334155;\n  }\n\n  .user-type-name {\n    color: #f1f5f9;\n  }\n\n  .user-type-description {\n    color: #94a3b8;\n  }\n\n  .back-button {\n    background: #334155;\n    color: #f1f5f9;\n    border-color: #475569;\n  }\n\n  .back-button:hover {\n    background: #475569;\n    border-color: #64748b;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
